// https://vuex.vuejs.org/en/actions.html
import Vue from 'vue';
import axios from 'axios';
import { workflow } from 'theagent-status';
import { errorHandler } from '@/store/modules/global_helpers';

const {
  IN_PROGRESS, DONE, ERROR, RE_TRY,
} = workflow;

// milli seconds
const DELAY = 5000;

const BASE_URI = '/api/v1/pim/classification-from-marketplace';
const BASE_URI_V2 = '/api/v2/pim/classification-from-marketplace';
const namespace = 'store.modules.classification-from-marketplace.actions';

export default {
  list({
    state, commit, getters, dispatch,
  }) {
    if (state.state === ERROR) {
      return Promise.reject(new Error(`${namespace}.something.occured.on.server`));
    }
    if (state.state === RE_TRY) {
      return Promise.resolve([]);
    }
    if (state.state === DONE) {
      return Promise.resolve(getters);
    }
    if (state.state === IN_PROGRESS) {
      commit('set_state', RE_TRY);
      return new Promise(resolve => setTimeout(() => resolve(dispatch('list')), DELAY));
    }
    commit('set_state', IN_PROGRESS);
    return new Promise((resolve, reject) => {
      axios
        .get(`${BASE_URI}`)
        .then((response) => {
          if (typeof response === 'undefined') {
            commit('set_state', ERROR);
            throw new TypeError(`${namespace}.response.failed`);
          }
          commit('set_state', DONE);
          commit('set_classifications', response.data.result);
          return resolve(response.data);
        })
        .catch((error) => {
          commit('set_state', ERROR);
          return reject(error);
        });
    });
  },
  get({ commit }, remoteCode) {
    Vue.$log.log(`${namespace}.get.${remoteCode}.started`);
    return new Promise((resolve, reject) => {
      axios
        .get(`${BASE_URI}/${remoteCode}`)
        .then(async (response) => {
          if (typeof response === 'undefined') {
            throw new TypeError(`${namespace}.${remoteCode}.not.found`);
          }
          commit('set_classification', response.data.result);
          return resolve(response.data.result);
        })
        .catch((error) => {
          Vue.$log.error(error.message);
          return errorHandler(reject)(error);
        });
    });
  },
  addAttributeForAttributeFromMarketplace({ commit }, payload) {
    Vue.$log.log(`${namespace}.addattributeforattributefrommarketplace.${payload.cfmRemoteCode}.started`);
    return axios
      .put(`${BASE_URI_V2}/${payload.cfmRemoteCode}/${payload.afmRemoteCode}/addAttribute`, payload)
      .then(async (response) => {
        if (typeof response.data === 'undefined') {
          throw new TypeError(`${namespace}.addattributeforattributefrommarketplace.${payload.cfmRemoteCode}.not.found`);
        }
        commit('classification/set_afm', {
          ...payload,
          attributes: response.data.result.attributesAssociated,
        }, { root: true });
        return true;
      })
      .catch((error) => {
        Vue.$log.error(error);
        return false;
      });
  },
};
